module.exports = __webpack_public_path__ + "img/howitworks_hero_mobile.dba5db17.jpg";